import { Bot, Globe, CalendarCheck, Footprints, Phone, Instagram, Facebook, Search, Users, PenLine } from "lucide-react";

export const LEAD_STAGES = ["new", "contacted", "follow_up", "won", "lost"];
export const STAGE_LABELS = { new: "New", contacted: "Contacted", follow_up: "Follow-up", won: "Booking Confirmed", lost: "Closed / Not Proceeding" };
export const CLOSE_REASONS = { not_interested: "Not interested", no_response: "No response", price: "Price", went_elsewhere: "Went elsewhere", duplicate: "Duplicate enquiry", spam: "Spam", other: "Other" };

export const SOURCE_META = {
  shally: { label: "Shally AI", icon: Bot, tone: "bg-violet-50 text-violet-700 border-violet-200" },
  website: { label: "Website", icon: Globe, tone: "bg-sky-50 text-sky-700 border-sky-200" },
  booking_page: { label: "Booking page", icon: CalendarCheck, tone: "bg-sky-50 text-sky-700 border-sky-200" },
  walk_in: { label: "Walk-in", icon: Footprints, tone: "bg-amber-50 text-amber-800 border-amber-200" },
  phone: { label: "Phone", icon: Phone, tone: "bg-slate-50 text-slate-700 border-slate-200" },
  instagram: { label: "Instagram", icon: Instagram, tone: "bg-pink-50 text-pink-700 border-pink-200" },
  facebook: { label: "Facebook", icon: Facebook, tone: "bg-blue-50 text-blue-700 border-blue-200" },
  google: { label: "Google", icon: Search, tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  referral: { label: "Referral", icon: Users, tone: "bg-teal-50 text-teal-700 border-teal-200" },
  manual: { label: "Manual", icon: PenLine, tone: "bg-slate-50 text-slate-700 border-slate-200" },
};
export const sourceMeta = (s) => SOURCE_META[s] || { label: (s || "Other").replace(/_/g, " "), icon: PenLine, tone: "bg-slate-50 text-slate-700 border-slate-200" };

export const STAGE_TONE = { new: "bg-violet-50 text-violet-700 border-violet-200", contacted: "bg-sky-50 text-sky-700 border-sky-200",
  follow_up: "bg-amber-50 text-amber-800 border-amber-200", won: "bg-emerald-50 text-emerald-700 border-emerald-200", lost: "bg-slate-100 text-slate-600 border-slate-200" };
export const PRIORITY = { urgent: { label: "Urgent", tone: "bg-rose-600 text-white border-rose-600" }, high: { label: "High", tone: "bg-orange-50 text-orange-700 border-orange-200" },
  normal: { label: "Normal", tone: "bg-slate-50 text-slate-600 border-slate-200" }, low: { label: "Low", tone: "bg-slate-50 text-slate-400 border-slate-200" } };

// Lead facts regardless of where they came from (Connect intake keeps them under `connect`).
export function leadInfo(l) {
  const c = l.connect || {};
  return { pet: c.pet_name || l.pet_name || "", species: c.species || l.species || "", service: c.requested_service || l.requested_service || "",
    when: [c.preferred_date, c.preferred_time].filter(Boolean).join(" "), source: c.channel || l.source || "", bookingId: c.booking_id || "",
    apptStatus: c.appointment_status || "", followUp: c.follow_up_required ? (c.follow_up_reason || "Follow-up required") : "",
    callRef: c.provider === "shally" ? c.external_ref || "" : "", breed: c.pet_breed || "", altPhone: c.alternate_phone || "",
    availability: c.availability_state || "" };
}

export const telLink = (m) => `tel:+91${String(m || "").replace(/\D/g, "").slice(-10)}`;
export const waLink = (m) => `https://wa.me/91${String(m || "").replace(/\D/g, "").slice(-10)}`;

export function ago(iso) {
  if (!iso) return "";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 60) return `${Math.max(m, 0)}m ago`;
  if (m < 1440) return `${Math.round(m / 60)}h ago`;
  return `${Math.round(m / 1440)}d ago`;
}

export const stamp = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }) : "");
export const niceDate = (d) => { try { return d ? new Date(`${d.slice(0, 10)}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" }) : ""; } catch { return d; } };
